import AppSocial from '@/components/widgets/social'

export default {
  name: 'AppFooter',
  components: { AppSocial },
  computed: {
    VERSION () {
      return VERSION // eslint-disable-line
    }
  }
}
